import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/opportunities/$opportunityId',
)({
  beforeLoad: ({ params: { organizationId, opportunityId } }) => {
    throw redirect({
      to: '/organization/$organizationId/issues/$opportunityId',
      params: { organizationId, opportunityId },
    })
  },
})
